module.exports = ".europa_image{text-align:right;padding-top:13px;padding-right:30px}.version_text{font-size:x-small;padding-top:25px}\n"